import React from "react";
import ServicesLeads from "../Components/ServiceLeads/ServicesLeads";

const ServicesLeadsPage = () => {
  return (
    <div>
      <ServicesLeads />
    </div>
  );
};

export default ServicesLeadsPage;
